import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { LcsAudioPlayerComponent } from '@lcs/shared/audio-player';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { IconsModule } from 'src/app/common-components/icons/icons.module';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { FormatSecondsPipeModule } from 'src/app/pipes/format-seconds/format-seconds-pipe.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { CallDetailDialogComponent } from './call-detail-dialog.component';

@NgModule({
   declarations: [CallDetailDialogComponent],
   imports: [
      AddSpacesPipeModule,
      CommonModule,
      MatDialogModule,
      MatExpansionModule,
      MatIconModule,
      MatButtonModule,
      MatMenuModule,
      IconsModule,
      FileUrlPipeModule,
      FormatPhoneNumbersPipeModule,
      FormatSecondsPipeModule,
      ScrollingModule,
      LcsResponsiveTableModule,
      LcsAudioPlayerComponent,
   ],
   providers: [CallDetailDialogComponent, DatePipe],
})
export class CallDetailDialogModule {}
